import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getUserInfo, getWebSessionId, getCsaUserAuth } from "../../actions/user";
import { getCsaUserInfo } from '../../actions/tenant';
import { withRouter } from 'react-router-dom';
import { Helmet } from "react-helmet";

class CSAHome extends Component{
    constructor(){
        super()
        this.state = {
            loginForm: false,
            user_name: "",
            cons_password: "",
            cons_first_name: "",
            cons_last_name: "",
            cons_email_id: "",
        }
        this.loginValidator = new SimpleReactValidator();
        // this.validator = new SimpleReactValidator();
    }
    componentDidMount() {
        if (this.props.isAuth) {
            this.props.history.push(`/`)

            toast.success("Already Logged in");
            //this.props.history.push(`/csa-home`)
            this.props.history.push(`/`)

            // this.props.history.goBack()
        }
    }
    handleLoginForm = () => {
        this.setState({
            loginForm: true
        })
    }
    handleChange = (event) => {
        this.setState({ [event.target.id]: event.target.value });
    }

    handleLogin = async(event) => {
        event.preventDefault();
        if (this.loginValidator.allValid()) {
            // const { connection_id } = this.props
            console.log(this.props)
            // this.props.getUserInfo({ ...this.state, auth_type: "L", connection_id })
            // this.props.getWebSessionId(connection_id);
            const csaAuth = {
                "csa_user_id": this.state.user_name,
                "csa_password": this.state.cons_password
              }
          const result =  await this.props.getCsaUserInfo(csaAuth)
          console.log(result.connection_id)
            if( result.connection_id && result.connection_id !== '' && result.connection_id !== null && result.connection_id !== undefined){
                this.props.getWebSessionId(result.connection_id);
                setTimeout(function() {
                if (!!!this.props.error) {
                    localStorage.setItem('csa_user_id', this.state.user_name);
            localStorage.setItem('csa_password', this.state.cons_password);
                    this.props.history.push(`/csa-home`)
                }
            }.bind(this), 50);
        }
        else {
            this.props.history.push(`/`)
            this.loginValidator.showMessages();
            this.forceUpdate();
        }
        } else {
            this.props.history.push(`/`)
            this.loginValidator.showMessages();
            this.forceUpdate();
        }
    }

    render(){
        const store_details = this.props.store_details;
        return(
            <React.Fragment>
                <div class="csa-home-section">
                    <div className="csa-inner-home">
                        <div className="left-csahome-section">
                            <div className="logo-section">
                                <Link to="/">
                                    <img src="https://login.olabi.ooo/images/logo.png" alt=""/>
                                </Link>
                            </div>
                        {!this.state.loginForm ?
                        <div className="csahome-banner">
                            <div style={{display:'none' }} className='mobile-bottom-img'  >  
                         <img src={this.props.login_image} alt="" />
                         {/* <img src='https://d3sxbqfs360wl5.cloudfront.net/live/olabi_sym_content/application_brand_image/ros/original/olabi_login_2020-11-26_053931.jpg' /> */}
                         </div> 
                            {/* <p style={{fontFamily: 'Lato, sans-serif',fontSize:21,overflow:'hidden'}}><h2 style={{fontSize:21}}>
                            {store_details ? store_details.Login_quote : ''}
                            </h2></p> */}
                            <div className='homeText'>
                            <h2 className='quoteText'>{store_details ? store_details.quote1 : ''}</h2>
                            <h2 className='quoteText'>{store_details ? store_details.quote2 : ''} </h2>
                            <h2 className='quoteText'>{store_details ? store_details.quote3 : ''}</h2>
                            <h2 className='quoteText'>{store_details ? store_details.quote4 : ''}</h2>
                            <h2 className='quoteText'>{store_details ? store_details.quote5 : ''}</h2>
                            <p className='quoteAuthor'> {store_details ? store_details.author : ''}</p>
                            {/* <p>{store_details ? store_details.Login_quote_author : ''}</p> */}
                            <div className="mobile-view" style={{display:'none'}}>
                            <button onClick={this.handleLoginForm} >
                                <img src="https://login.olabi.ooo/images/assets/right-arrow.png" alt="" />
                            </button>
                        </div>
                        </div>
                        <p></p>
                        
                        

                        </div>
                        :
                        <div className="csahome-loginform">
                            <form className="theme-form mt-4" autocomplete="off">
                                <div className="form-row">
                                    <div className="col-md-12">
                                        <label>User Name</label>
                                        <input type="text" className="form-control" id="user_name"
                                            placeholder="Enter your user name*" autocomplete="new" value={this.state.user_name} onChange={(e) => this.handleChange(e)} />
                                        {this.loginValidator.message('user name', this.state.user_name, 'required')}
                                    </div>
                                    <div className="col-md-12" >
                                        <label>Password</label>
                                        <input type="password" className="form-control" id="cons_password"
                                            placeholder="Enter your password*"  autocomplete="new" value={this.state.cons_password} onChange={(e) => this.handleChange(e)} />
                                        {this.loginValidator.message('password', this.state.cons_password, 'required')}
                                    </div>

                                    <div className="col-md-12 login-button-arrow">
                                        <button type="button" onClick={(e) => this.handleLogin(e)} style={{ width: "100%" }}>
                                            <img src="https://login.olabi.ooo/images/assets/rightactive-arrow-b.png" alt="" />
                                        </button>
                                    </div>
                                    
                                </div>
                            </form>
                        </div>
                        }

                        {!this.state.loginForm &&
                        <div className="loginform-arrow mobile-loginform-arrow">
                            <button onClick={this.handleLoginForm}>
                                <img src="https://login.olabi.ooo/images/assets/right-arrow.png" alt="" />
                            </button>

 
                        </div>
                        
                        }

                        </div>
                        <div className="right-csahome-section">
                            <img src={this.props.login_image} alt=""/>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    isAuth: state.user.isAuth,
    // connection_id: state.tenant.connection_id,
    error: state.tenant.error,
    store_details: state.tenant.store_details,
    login_image: state.tenant.login_image,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getUserInfo, getWebSessionId, getCsaUserAuth, getCsaUserInfo },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(CSAHome));